import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorBookingItemSettingVenue } from '../editor-booking-item-setting/editor-booking-item-setting-venue.model';


@Component({
    selector: 'eas-editor-booking-item-setting-value-venue',
    templateUrl: './editor-booking-item-setting-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingValueVenueComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSettingVenue;

  private destroyed$ = new Subject<void>();

  venueNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.venueNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(venueNames => {
        this.venueNames = venueNames;
        this.value = this.getValue();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.venueNames === undefined) {
      return $localize `Not available`;
    }

    return this.itemSetting.getIdAsString(this.venueNames);
  }
}
